// eslint-disable-next-line import/prefer-default-export
export enum ESearchKeyType{
  Input = 'Input',
  HotWord = 'HotWord'
}